import { makeAutoObservable } from "mobx";
import {
  EmptyGroupLearningPathResponseImpl,
  GroupLearningPathResponseApi,
  ObservableGroupLearningPathPropImpl,
} from "../../DTO/ServerResponseType/Group/GroupLearningPath";
import { ModulesStore } from "../ModuleStores/ModulesStore";

export class GroupLearningPathWindowStore {
  groupLearningPath: ObservableGroupLearningPathPropImpl;
  modulesStore: ModulesStore = new ModulesStore();

  constructor() {
    this.groupLearningPath = new ObservableGroupLearningPathPropImpl(
      new EmptyGroupLearningPathResponseImpl()
    );
    makeAutoObservable(this);
  }

  setGroupLearningPath = (groupLearningPath: GroupLearningPathResponseApi) => {
    this.groupLearningPath = new ObservableGroupLearningPathPropImpl(
      groupLearningPath
    );

    this.modulesStore.setModules(groupLearningPath.groupLearningPathModules);
  };
}
